import React from 'react';
import './ImageContainer.scss';

function ImageContainer(props) {
  return (
    <div className="image-container">
      <p className="wid-50">“</p>
      <p className="wid-50">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam vulputate
        eget mi non aliquam. Suspendisse id efficitur lorem. Vivamus facilisis
        fringilla leo, et blandit arcu mattis porttitor. Phasellus consequat
        augue.
      </p>
      <p className="wid-50">⅃</p>
    </div>
  );
}

export default ImageContainer;
